'use client'
import React from 'react'
import { Box, Typography } from '@mui/material';
import DesignFavoriteButton from '../FavoriteButtons/DesignFavoriteButton';
import trackRecentlyViewedItem from '@/pages/api/trackRecentlyViewedItem';
interface EachDesignCardProps {
    eachDesign: any;
    handleMenuCloseDesignDetail: (isMenuClosed: boolean) => void;
    handleSelectedDesignDetailId: (itemId: string) => void;
}
const EachDesignCard: React.FC<EachDesignCardProps> = (props) => {
    console.log('EachDesignCard component----------------------------------')
    //props
    const { eachDesign, handleMenuCloseDesignDetail, handleSelectedDesignDetailId } = props
    //handlers
    function handleDetailsClick(event:any) {
        event.stopPropagation()
        handleSelectedDesignDetailId(eachDesign.itemId as any)
        handleMenuCloseDesignDetail(false)
        trackRecentlyViewedItem({
            itemId:eachDesign.itemId,
            type: 'design',
            name: eachDesign.name,
            image: eachDesign.image,
            isPersonalizable: eachDesign?.isPersonalizable
          });
    }
    return (
        <Box component="div" sx={{ margin: '0 8px 8px 8px', paddingBottom: '5px', border: 'solid 1px #7F7F7F', borderRadius: '10px', height: '100%', position: 'relative', overflow: 'hidden' }}>
            <img src={eachDesign.image} alt={eachDesign.name} style={{ width: '100%', borderRadius: '10px 10px 0 0', height: '120px', objectFit: 'cover',cursor:'pointer' }} onClick={handleDetailsClick}/>
            {/* <Box component="div" sx={{position: 'absolute', background: 'rgba(255,255,255,0.7)', height: '120px', width: '100%', top: '0', left: '0', color: '#000', fontSize: '12px', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>In Project</Box>*/}
            <Box component='div' sx={{ position: 'absolute', left: '10px', top: '10px' }}>
                <DesignFavoriteButton eachDesign={eachDesign} fontSize='20px' />
            </Box>
            <Typography sx={{ textAlign: 'center', fontWeight: '700', fontSize: '13px' }}>{eachDesign.name}</Typography>
            <Box component="div" sx={{ display: 'flex', justifyContent: 'center' }}>
                {/* <Typography sx={{ color: '#0D908E', fontWeight: '700' }}>Add to project</Typography>  */}
                {/* <Typography sx={{ margin: '0 5px' }}>•</Typography>  */}
                <Typography onClick={handleDetailsClick} sx={{ color: '#0D908E', fontWeight: '700', cursor: 'pointer' }}>Details</Typography>
            </Box>
        </Box>
    )
}
export default EachDesignCard;